import React from 'react'
import { SidePanel } from '@node-space/ui-components'
import {
  PaymentLimitSidePanelBody,
  PaymentLimitSidePanelHeader,
} from 'components/PaymentLimits/PaymentLimitSidePanelContent'
import type { Limit } from 'types/paymentLimits'

interface PaymentLimitSidePanelProps {
  isOpen: boolean
  limit: Limit | null
  onClose: () => void
}

export const PaymentLimitSidePanel = ({ isOpen, limit, onClose }: PaymentLimitSidePanelProps) => {
  return (
    <SidePanel
      id="payment-limit-side-panel"
      isOpen={isOpen}
      onClose={onClose}
      header={<PaymentLimitSidePanelHeader limit={limit} />}
      body={
        <PaymentLimitSidePanelBody
          limit={limit}
          titleKeys={{
            currency: 'paymentLimits.currency',
            paymentMethod: 'paymentLimits.paymentMethod',
            limitType: 'paymentLimits.limitTypeLabel',
          }}
        />
      }
    />
  )
}
